import React, { useEffect, useState } from "react"
import { graphql, navigate } from "gatsby"
import axios from 'axios';
import { loadStripe } from '@stripe/stripe-js';
import Layout from "../components/layout/layout"
import Header from '../components/header/header'
import InfoList from '../components/infoList/infoList'
import PhoneImage from '../components/phoneImage/phoneImage'
import SignUpForm from '../components/signupForm/signupForm'
import '../styles/index.css'

const stripePromise = loadStripe(process.env.GATSBY_STRIPE_SECRET_KEY);

const howToDescription = {
  headerTitle: 'How it works',
  subTitle: 'Sunset is easy to use on any smartphone. \n Login and begin tackling your daily tasks.',
  infoList: [
    {
      title: 'Sign up today',
      description: 'No contracts. Just create an account, check your email for the link to download the app, and login to get started.'
    }, {
      title: 'Take a burnout assessment',
      description: 'Identify how isolation and burnout impact you. Your answers are anonymous.'
    }, {
      title: 'Receive a personalized burnout treatment plan',
      description: 'On-demand help anytime you need it. Designed by experts, our treatment plans consist of real-life actions you can take daily.'
    }, {
      title: 'Learn new insights',
      description: 'Watch your recovery over time. Learn what actions are helping you recover the most.'
    }
  ]
}

function hexToRgbA(hex, alpha = 1) {
  var c;
  if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
      c= hex.substring(1).split('');
      if(c.length== 3){
          c= [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c= '0x'+c.join('');
      return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+`,${alpha})`;
  }
  throw new Error('Bad Hex');
}

const userApiClient = axios.create({
  // baseURL: 'https://api.sunset.health/api/v1',
  baseURL: process.env.GATSBY_BASE_API_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  timeout: 4000,
})

const getCompanyConfig = async (org) => {
  try {
    const response = await userApiClient.get(`/organizations/${org}/organization_products`);
    return {
      companyConfig: {...response.data}, 
      headers: {   
        token: response.headers['token-access'],
        uid: response.headers.uid,
        client: response.headers.client 
      }
    };
  } catch (err) {
    return {err: { statusCode: 404 }, companyConfig: null}
  }
}

const EmployerPortal = ({ data, location }) => {
  const siteTitle = data.site.siteMetadata.title;
  const company = data.site.siteMetadata.company;

  const [fontColor, setfontColor] = useState('#74c5d8');
  const [howToColor, sethowToColor] = useState('#bf982f');
  const [logo, setLogo] = useState(null);
  const [companyConfig, setCompanyConfig] = useState({});
  const [priceID, setPriceID] = useState(null);

  useEffect(() => {
    setfontColor('#74c5d8');
    sethowToColor('#bf982f');
  }, [])

  useEffect(() => {
    getCompanyConfig('karenthomson')
    .then(({companyConfig}) => {
      setCompanyConfig({...companyConfig});
      const {configuration} = companyConfig;
      setfontColor(configuration.secondary_color);
      sethowToColor(configuration.primary_color);
      setLogo(configuration.logo_url)

      const {stripe_products} = companyConfig;
      if (stripe_products && stripe_products.length > 0) {
        setPriceID(companyConfig.stripe_products[0].stripe_prices[0].stripe_price_id);
      }
    })
    .catch(({err, companyConfig}) => {});
  }, [])
  
  const redirectToCheckout = async (priceId, quantity = 1, customer_email, successURL, cancelURL) => {
    if (!priceId) {
      navigate(cancelURL)
    }
    const stripe = await stripePromise;
    const { error } = await stripe.redirectToCheckout({
      lineItems: [
        // Replace with the ID of your price
        {price: priceId, quantity: 1}
      ],
      customerEmail: customer_email,
      mode: 'subscription',
      successUrl: successURL,
      cancelUrl: cancelURL,
    });
    if (error) {
      alert(error.message)
    }
    // If `redirectToCheckout` fails due to a browser or network
    // error, display the localized error message to your customer
    // using `error.message`.
  }

  const {configuration, id, name, url_slug, stripe_purchase_flow} = companyConfig;

  return (
    <Layout location={location} title={siteTitle}>
      <Header fontColor={fontColor} logo={logo}/>
      <section className='ui-section hero-section'>
        <div className='ui-container'>
          <div className='ui-col hero-content'>
            <h1 className='ui-h1'>Sunset empowers you to take control of your burnout</h1>
            <h3 className='ui-h3 hero-subtitle' style={{ color: fontColor}}>START YOUR JOURNEY WITH US TODAY</h3>
          </div>
          <div className='ui-col hero_img'>
            <img className='ui-hero_img' src={require(('../../content/assets/doctor_hero_image.png'))} />
          </div>
        </div>
      </section>
      <section className='ui-section signup'>
        <div className='ui-container'>
          <div className='ui-grid'>
            <div className='ui-col howto-col' style={{ backgroundColor: hexToRgbA(howToColor, 0.1)}}>
              <InfoList {...howToDescription} fontColor={fontColor} />
              <div className='howto-img-container'>
                <PhoneImage sun={hexToRgbA(howToColor, 0.5)} />
              </div>
            </div>
            <div className='ui-col signup-col' style={{ backgroundColor: hexToRgbA(fontColor, 0.1)}}>
              <SignUpForm 
                stripe_purchase_flow={stripe_purchase_flow} 
                orgID={id}
                onSubmitHandler={(customer_email) => redirectToCheckout(priceID, 1, customer_email, process.env.GATSBY_PURCHASE_PAGE_URL+`/premium-submission`, process.env.GATSBY_PURCHASE_PAGE_URL+`/success-submission` )} 
                fontColor={fontColor} 
              />
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default EmployerPortal

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`
